export default __webpack_public_path__ + "static/media/colibriPicoDeHoz.c5a83dd0.png";